import { useQueryClient } from "@tanstack/react-query";
import { Loader } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { API, applyAuthorizationHeader } from "../../../services/apiService";
import { setAuthorizationToken } from "../../../services/auth/authToken";

const LinkedInCallback = () => {
	const [isLoading, setIsLoading] = useState(true);

	const queryParams = new URLSearchParams(window.location.search);
	const code = queryParams.get("code");

	const navigate = useNavigate();
	const queryClient = useQueryClient();

	useEffect(() => {
		const fetchLinkedInData = async () => {
			if (code) {
				try {
					const { data } = await API.post("auth/linkedin", {
						authCode: code,
						source: "WEB",
					});

					if (data.access_token) {
						const expiresAt = new Date(Date.now() + data.expires_in * 1000);
						// Reset the previous session before the new token activates the global account observer.
						queryClient.removeQueries({ queryKey: ["user", "account"], exact: true });
						setAuthorizationToken(data.access_token, expiresAt);
						applyAuthorizationHeader(data.access_token);

						navigate("/profile", { replace: true });
					} else {
						toast.error("LinkedIn login failed");
						navigate("/signin");
					}
				} catch {
					toast.error("LinkedIn login failed");
					navigate("/signin");
				} finally {
					setIsLoading(false);
				}
			}
		};

		fetchLinkedInData();
	}, [code, navigate, queryClient]);

	return <div className="hidden">{isLoading ? <Loader /> : null}</div>;
};

export default LinkedInCallback;
